import { IFeed } from "@/types/IFeed";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: IFeed[] = [];

export const BookmarkSlice = createSlice({
  name: "bookmark",
  initialState,
  reducers: {
    setBookmarkFeed: (state, action: PayloadAction<IFeed[]>) => {
      if (action.payload.length === 0) {
        return [];
      } else {
        const ids = new Set(state.map((d) => d.id));
        const filtered = [...action.payload.filter((d) => !ids.has(d.id))];
        const updatedState = [...state, ...filtered];
        return updatedState;
      }
    },
  },
});

export const { setBookmarkFeed } = BookmarkSlice.actions;

export default BookmarkSlice.reducer;
